import { formatWithConfiguredDate } from "./dateFormatStore";

// Formats a date using the company's configured Date Format setting
// (Account Settings -> Additional Information). Falls back to "-" for
// missing/invalid values. This is the function to use anywhere a date is
// displayed in a list, detail view, or table.
export function formatDate(timestamp) {
  return formatWithConfiguredDate(timestamp);
}

export function formatFormDate(dateString) {
  if (!dateString) {
    return "-";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "-";
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const convertDate = `${year}-${month}-${day}`
  return convertDate;
}

export function formatToDDMMYYYY(dateString) {
  if (!dateString) {
    return "-";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "-";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

/**
 * Display date exactly as it comes from API without any formatting
 * Handles various date formats like "12/10/2020", "2020/10/11", "25/11/2025", etc.
 * @param {string|number|null|undefined} dateValue - Date value from API
 * @returns {string} - Returns the date as-is or "-" if empty/invalid
 */
export function displayDateAsIs(dateValue) {
  // Validate input - check for empty strings, null, undefined
  if (!dateValue || (typeof dateValue === 'string' && dateValue.trim() === "")) {
    return "-";
  }
  
  // Return the date exactly as it comes from the API (e.g., "12/10/2020", "2020/10/11", etc.)
  return dateValue;
}